"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Pressable = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Pressable"));
var _Text = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Text"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _ThemeProvider = require("../../ThemeProvider");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectPressProps, pressPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.pressProps, _utils.viewProps]);
const [selectTextProps, textPropTypes] = (0, _utils.selectSystemProps)([_utils.textProps]);
const selectContainerStyles = _ref => {
  let {
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom = 0,
    borderBottomColor,
    borderBottomWidth = 0,
    borderBottomStyle,
    flex,
    alignItems,
    justifyContent
  } = _ref;
  return {
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom: paddingBottom - borderBottomWidth,
    borderBottomColor,
    borderBottomWidth,
    borderBottomStyle,
    flex,
    alignItems,
    justifyContent,
    ..._Platform.default.select({
      // Removes the default browser :focus outline
      web: {
        outline: 'none'
      }
    })
  };
};
const selectTextStyles = _ref2 => {
  let {
    fontSize,
    fontScaleCap,
    lineHeight,
    letterSpacing,
    fontWeight,
    fontName,
    color
  } = _ref2;
  return (0, _ThemeProvider.applyTextStyles)({
    fontSize,
    fontScaleCap,
    lineHeight,
    letterSpacing,
    fontWeight,
    fontName,
    color
  });
};
const CarouselTabsPanelItem = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    title,
    selected,
    inactive,
    variant,
    tokens,
    accessibilityRole = 'tab',
    ...rest
  } = _ref3;
  // Workaround for React Native Web https://github.com/necolas/react-native-web/issues/2357
  // Don't allow disabled to be set while focus is true else focus state gets locked `true`
  // (must refocus _after_ calling `goTo`, else focus target content is not up to date)
  const [isFocused, setIsFocused] = _react.default.useState(false);
  const disabled = (inactive || selected) && !isFocused;
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('CarouselTabsPanelItem', tokens, variant);
  const resolveTokens = pressState => getTokens((0, _utils.resolvePressableState)(pressState, {
    selected
  }));
  const getContainerStyle = pressState => selectContainerStyles(resolveTokens(pressState));
  const getTextStyle = pressState => selectTextStyles(resolveTokens(pressState));
  const {
    onPress,
    ...selectedPressProps
  } = selectPressProps(rest);
  const handleKeyDown = event => {
    // Allow using the spacebar for navigation
    if (event?.key === ' ') onPress(event);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pressable.default, {
    onPress: onPress,
    style: getContainerStyle,
    accessibilityRole: accessibilityRole,
    ref: ref,
    onKeyDown: handleKeyDown,
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    disabled: disabled,
    ...selectedPressProps,
    children: pressState => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      style: getTextStyle(pressState),
      ...selectTextProps(rest),
      children: title
    })
  });
});
CarouselTabsPanelItem.displayName = 'CarouselTabsPanelItem';
CarouselTabsPanelItem.propTypes = {
  ...pressPropTypes,
  ...textPropTypes,
  title: _propTypes.default.string.isRequired,
  selected: _propTypes.default.bool,
  tokens: (0, _utils.getTokensPropType)('CarouselTabsPanelItem'),
  variant: _utils.variantProp.propType
};
var _default = exports.default = CarouselTabsPanelItem;